import { render, staticRenderFns } from "./hNoData.vue?vue&type=template&id=718fe6b3&scoped=true&"
import script from "./hNoData.vue?vue&type=script&lang=js&"
export * from "./hNoData.vue?vue&type=script&lang=js&"
import style0 from "./hNoData.vue?vue&type=style&index=0&id=718fe6b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718fe6b3",
  null
  
)

export default component.exports